import { useTranslation } from 'react-i18next'

export default function DateDiscountTermSection({ form, setField, hideCorrectedNumber = false }) {
	const { t } = useTranslation()

	return (
		<div className={`grid grid-cols-1 ${hideCorrectedNumber ? 'md:grid-cols-2' : 'md:grid-cols-3'} gap-3`}>
			<div>
				<label className="block text-sm font-medium text-gray-700 mb-1">{t('korekty.form.date')}</label>
				<input
					type="date"
					value={form.invoiceDate}
					onChange={e => setField('invoiceDate', e.target.value)}
					className="block w-full rounded-lg border-0 py-2.5 px-3.5 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600"
				/>
			</div>

			<div>
				<label className="block text-sm font-medium text-gray-700 mb-1">{t('korekty.form.dueDate')}</label>
				<input
					type="date"
					value={form.dueDate}
					onChange={e => setField('dueDate', e.target.value)}
					className="block w-full rounded-lg border-0 py-2.5 px-3.5 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600"
				/>
			</div>

			{!hideCorrectedNumber && (
				<div>
					<label className="block text-sm font-medium text-gray-700 mb-1">
						{t('korekty.form.correctedInvoiceNumber')}
					</label>
					<input
						type="text"
						value={form.correctedInvoiceNumber || ''}
						onChange={e => setField('correctedInvoiceNumber', e.target.value)}
						placeholder={t('korekty.form.correctedInvoiceNumberPlaceholder')}
						className="block w-full rounded-lg border-0 py-2.5 px-3.5 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600"
						required
					/>
				</div>
			)}
		</div>
	)
}
